// element-ui language pack
import zhLocale from "element-ui/lib/locale/lang/zh-CN";
export default {
  ...zhLocale,
  数字资产化平台: "Digital Asset Tokenization Platform",
  请设置社区名称: "Please set community name",
  "将现实世界资产(Real World Assets)通过区块链技术数字化，提供透明、高效的资产交易与管理服务":
    "Digitizing Real World Assets through blockchain technology, providing transparent and efficient asset trading and management services",
  目标IRR: "Target IRR",
  浏览项目: "Browse Projects",
  主推产品: "Featured Products",
  运作方式: "How It Works",
  目标收益率: "Target Yield",
  了解完整流程: "Learn the Full Process",
  资产透明: "Asset Transparency",
  "所有资产信息上链可查,确保真实可靠":
    "All asset information is recorded on the blockchain, ensuring authenticity and reliability",
  收益稳定: "Stable Returns",
  "精选优质资产,提供稳定可观收益":
    "Curated high-quality assets providing stable and considerable returns",
  交易便捷: "Convenient Trading",
  "7x24小时交易,随时买卖变现":
    "7x24 hour trading, buy and sell anytime for liquidity",
  安全合规: "Security & Compliance",
  "多重安全保障,合规运营": "Multi-layered security, compliant operations",
  "创建账户并完成客户身份验证(KYC)":
    "Create an account and complete KYC verification",
  所有投资者均需满足此要求: "This requirement applies to all investors",
  浏览标记化项目: "Browse Tokenized Projects",
  "多户型住宅、商业地产、综合体、零售地产和酒店资产":
    "Multi-family homes, commercial real estate, mixed-use developments, retail properties, and hotel assets",
  连接你的钱包: "Connect your wallet",
  "通过MetaMask进行自我托管,或使用Ternova的平台钱包":
    "Use MetaMask for self-custody, or use Ternova's platform wallet",
  数字化投资与持有: "Digital Investment & Holding",
  "代币代表特殊目的载体(SPV)或基金中的股权":
    "Tokens represent equity in a Special Purpose Vehicle (SPV) or fund",
  条件: "Requirements",
  已完成: "Completed",
  去完成: "Go to complete",
  确认申请: "Confirm Application",
  申请社区: "Apply for Community",
  申请合伙人: "Apply as Partner",
  邀请: "Invite",
  个会员: " members",
  认购资产价值达: "Subscribed asset value reaches",
  社区人数达到: "Community size reaches",
  人: "",
  个人认购资产达: "Personal asset subscription reaches",
  社区会员认购资产价值达: "Community member subscription value reaches",
  请先完成申请条件: "Please complete the requirements first",
  不能超过50字符: "Cannot exceed 50 characters",
  获赞: "Likes",
  留言: "Comments",
  邀请好友: "Invite Friends",
  我发布的: "My Posts",
  暂无: "No data",
  人留言: " comments",
  人点赞: " likes",
  暂无数据: "No Data",
  "加载中...": "Loading...",
  加载更多: "Load More",
  社区名称: "Community Name",
  保存名字: "Save Name",
  请输入社区名称: "Please enter community name",
  最长20字符: "Max 20 characters",
  合伙人社区: "Partner Community",
  热门社区: "Hot Communities",
  我的社区: "My Community",
  已经成为合伙人: "Already a Partner",
  话题详情: "Post Details",
  回复: "Reply",
  作者: "Author",
  收起回复: "Collapse reply",
  帮助文档: "Help Center",
  发布: "Post",
  "回复@": "Reply to @",
  "说点什么…": "Say something...",
  请输入内容: "Please enter content",
  "内容长度需控制在 5000 字符以内":
    "Content length must be within 5000 characters",
  帮助文档详情: "Help Center Details",
  关于我们: "About Us",
  TER币和RWA项目代币介绍: "Introduction to TER Token and RWA Project Tokens",
  数字资产平台: "Digital Asset Platform",
  查看和收购资产: "View and Acquire Assets",
  进入交易所: "Go to Exchange",
  数字资产银行: "Digital Asset Bank",
  快速兑换主流数字资产: "Quickly exchange mainstream digital assets",
  立即兑换: "Exchange Now",
  核心优势: "Core Advantages",
  "利益共享，打造合伙人共赢生态圈":
    "Shared benefits, creating a win-win partner ecosystem",
  进入社区: "Enter Community",
  联系我们: "Contact Us",
  访问官网: "Visit Official Website",
  月: "mo",
  日: "d",
  没有跳转链接: "No redirect link",
  请登录后进入: "Please log in first",
  可认购: "Available",
  邀请好友加入: "Invite friends to join",
  我的邀请: "My Invites",
  复制链接邀请好友: "Copy link to invite friends",
  复制成功: "Copy successful",
  复制失败: "Copy failed",
  邀请记录: "Invitation Records",
  "将现实世界资产(Real World Assets)通过区块链技术数字化，提供透明、高效的资产交易与管理服务。":
    "Digitizing Real World Assets through blockchain technology, providing transparent and efficient asset trading and management services.",
  进入RWA的世界: "Enter the World of RWA",
  资产列表: "Asset List",
  奖励余额: "Reward Balance",
  我的认购: "My Subscription",
  请选择类型: "Please select type",
  搜索资产: "Search Assets",
  已结束: "Ended",
  可预约: "Bookable",
  售价: "Offering Price",
  持有: "Holding",
  总值: "Total Value",
  剩余: "Remaining",
  认购代币: "Subscribe to Tokens",
  认购数量: "Subscription Quantity",
  认购资产: "Subscribe to Assets",
  确认认购: "Confirm Subscription",
  限购: "Limit: ",
  总价: "Total: ",
  预约认购数量: "Reservation Quantity",
  确认预约: "Confirm Reservation",
  "预约 CTA": "Reserve Now",
  提取代币: "Withdraw Tokens",
  确认提取: "Confirm Withdrawal",
  暂无可提取: "No withdrawable tokens at the moment",
  请输入提取数量: "Please enter withdrawal quantity",
  余额不足: "Insufficient balance",
  "交易进行中,请勿进行其他操作":
    "Transaction in progress, please do not perform other operations",
  "进行提取代币操作时，提取失败":
    "Withdrawal failed while attempting to withdraw tokens",
  提取余额: "Withdraw Balance",
  提取记录: "Withdrawal Records",
  认购进度: "Subscription Progress",
  底层资产介绍: "Underlying Asset Introduction",
  资产数字化详情: "Asset Tokenization Details",
  发行总量: "Total Issuance",
  枚: " Tokens",
  已售数量: "Sold Quantity",
  预约数: "Pre-order Quantity",
  锁定期: "Lock-up Period",
  个月: " months",
  分红机制: "Dividend Mechanism",
  实时数据: "Live Data",
  剩余可认购数量: "Remaining subscribable quantity",
  当前已预约数: "Current pre-order quantity",
  收益率: "Yield",
  平均分红金额: "Average Dividend Amount",
  项目认购: "Project Subscription",
  新项目预约: "New Project Pre-order",
  用户拒绝支付: "User rejected payment",
  剩余可认购数量为: "Remaining subscribable quantity is",
  请先进行KYC认证: "Please complete KYC verification first",
  KYC认证审核中: "KYC verification in progress",
  "上传图片/视频": "Upload Image/Video",
  "1、视频文件过大时压缩时间较长，请耐心等待":
    "1. Compression time is longer for large video files, please be patient",
  "2、若出现黑屏，请清理手机内存":
    "2. If the screen goes black, please clear your phone's memory",
  "3、建议您调整手机拍摄清晰度选择720p及以下的规格进行拍摄":
    "3. It is recommended to set your phone's recording resolution to 720p or lower",
  "仅支持图片或视频文件！": "Only image or video files are supported!",
  视频大小不能超过100MB: "Video size cannot exceed 100MB",
  图片大小不能超过5MB: "Image size cannot exceed 5MB",
  上传失败: "Upload failed",
  切换语言成功: "Language switched successfully",
  天前: " days ago",
  小时前: " hours ago",
  分钟前: " minutes ago",
  刚刚: "Just now",
  亿: "B",
  万: "K",
  没有更多了: "No more content",
  展开回复: "Expand reply",
  投资年限: "Investment Period",
  起投金额: "Minimum Investment Amount",
  认购价格: "Subscription Price",
  个: "",
  预约认购: "Pre-order Subscription",
  年: "y",
  立即认购: "Subscribe Now",
  KYC认证: "KYC Verification",
  连接钱包: "Connect Wallet",
  姓名: "Full Name",
  国籍: "Nationality",
  电话: "Phone Number",
  邮箱: "Email",
  所在区域: "Region",
  其他: "Other",
  请输入姓名: "Please enter your name",
  请输入国籍: "Please enter your nationality",
  请输入电话: "Please enter your phone number",
  请输入邮箱: "Please enter your email",
  请输入所在区域: "Please enter your region",
  "KYC认证(审核中)": "KYC Verification (Pending)",
  "KYC认证(审核通过)": "KYC Verification (Approved)",
  选择语言: "Select Language",
  确定: "Confirm",
  请输入: "Please enter",
  在Ternova投资代币化房地产: "Invest in Tokenized Real Estate on Ternova",
  "Ternova使得利用现代数字基础设施投资现实世界资产成为可能。 该流程旨在简洁、灵活且易于理解——尤其适合初次接触数字资产的投资者":
    "Ternova makes it possible to invest in Real World Assets using modern digital infrastructure. The process is designed to be simple, flexible, and easy to understand — especially for investors new to digital assets",
  创建帐户: "Create Account",
  流动性随时间变化: "Liquidity evolves over time",
  代币化旨在使所有权比传统的房地产结构更灵活:
    "Tokenization aims to make ownership more flexible than traditional real estate structures",
  "虽然投资应着眼于长远,但Ternova正在逐步增加额外的流动性选择":
    "While investments should be long-term focused, Ternova is gradually adding additional liquidity options",
  资源: "Resources",
  常见问题: "FAQ",
  重要注意事项: "Important Considerations",
  "所有投资都有风险。房地产投资可能会受到市场状况、运营因素和更广泛的经济趋势的影响":
    "All investments carry risk. Real estate investments can be affected by market conditions, operational factors, and broader economic trends",
  "代币化资产并非没有风险，其流动性可能不如公开交易的证券":
    "Tokenized assets are not without risk, and their liquidity may differ from publicly traded securities",
  "投资前请仔细审查所有项目材料和披露。每次发行都有完整的法律披露":
    "Please carefully review all project materials and disclosures before investing. Each offering has complete legal disclosures",
  "本页面内容旨在帮助您做出更充分的信息判断，并不替代您自身的评估或专业建议。":
    "The content on this page is intended to help you make a more informed judgment and does not substitute your own evaluation or professional advice.",
  "如需继续了解，您可以返回平台浏览可用项目，或查看投资流程说明":
    "To learn more, you can return to the platform to browse available projects or review the investment process",
  "谁可以在 Ternova 上投资": "Who can invest on Ternova?",
  什么时候需要进行身份认证: "When is identity verification required?",
  投资回报如何发放: "How are investment returns distributed?",
  "什么是真实世界资产(RWA)": "What are Real World Assets (RWA)?",
  "真实世界资产(RWA)是指在现实世界中存在的资产，例如房屋、车辆、股票等":
    "Real World Assets (RWA) are assets that exist in the physical world, such as houses, vehicles, stocks, etc",
  "在投资领域中，这通常包括房地产、基础设施以及持续经营、能够产生收入的企业资产":
    "In the investment field, this typically includes real estate, infrastructure, and ongoing, income-producing business assets",
  "与纯数字资产不同，真实世界资产依托于实体物业、合同现金流和真实经济活动，其价值基础不完全依赖市场情绪":
    "Unlike purely digital assets, RWAs rely on physical properties, contractual cash flows, and real economic activities; their value basis is not entirely dependent on market sentiment",
  符号化不动产解释: "Explanation of Tokenized Real Estate",
  代币化房地产说明: "Tokenized Real Estate Explanation",
  代币化房地产是指将房地产投资中的所有权以数字形式进行表示:
    "Tokenized real estate means representing ownership in real estate investments in digital form",
  "在Ternova上，代币代表真实世界资产中的股权权益，通常通过结构化投资载体持有。这些代币在功能上类似于数字化的股票凭证，代表所有权，而非投机行为":
    "On Ternova, tokens represent equity interests in Real World Assets, typically held through structured investment vehicles. Functionally, these tokens are similar to digital stock certificates, representing ownership, not speculative behavior",
  "代币化提升了所有权的管理与发行效率，但并不改变投资的基本逻辑。物业运营表现、收入能力和长期价值仍然是核心":
    "Tokenization improves the efficiency of ownership management and issuance but does not change the fundamental logic of the investment. Property operational performance, income capability, and long-term value remain core",
  与传统结构相比的符号化: "Tokenization Compared to Traditional Structures",
  代币化与传统结构的对比: "Tokenization vs. Traditional Structures",
  "传统房地产投资通常存在投资门槛较高、流程复杂、透明度有限等特点":
    "Traditional real estate investments are often characterized by high entry barriers, complex processes, and limited transparency",
  "代币化在多个方面带来改进空间：更易参与、更清晰的所有权表达、更简化的管理流程、数字化记录方式":
    "Tokenization offers improvements in several areas: easier participation, clearer ownership representation, simplified management processes, and digital record-keeping",
  "同时，代币化投资本质上仍是房地产投资，依然存在风险，需要审慎评估，并适合以长期视角参与":
    "At the same time, tokenized investment is still fundamentally real estate investment, carries risks, requires careful evaluation, and is suitable for a long-term perspective",
  钱包和数字所有权基础: "Wallet and Digital Ownership Basics",
  钱包与数字所有权基础说明: "Wallet and Digital Ownership Fundamentals",
  数字钱包是一种用于存储和管理数字化所有权记录的工具:
    "A digital wallet is a tool used to store and manage digital ownership records",
  "在 Ternova 上，钱包用于在完成投资后存储代币化的资产所有权。投资者可以选择自托管钱包（如 MetaMask），或使用平台支持的钱包方式":
    "On Ternova, wallets are used to store tokenized asset ownership after completing an investment. Investors can choose a self-custody wallet (like MetaMask) or use the platform-supported wallet option",
  "钱包并不会改变投资本身的性质，而是以更现代的方式安全地管理所有权，取代传统的纸质或实物凭证":
    "Wallets do not change the nature of the investment itself but securely manage ownership in a more modern way, replacing traditional paper or physical certificates",
  浏览可用项目: "Browse Available Projects",
  "在投资之前，所有投资者都必须完成身份验证。此过程有助于确保法规遵从性并保护平台的完整性。":
    "Before investing, all investors must complete identity verification. This process helps ensure regulatory compliance and protect the integrity of the platform.",
  您不需要连接钱包或完成身份验证来创建帐户:
    "You do not need to connect a wallet or complete identity verification to create an account",
  "一旦你有了账户，你就可以在平台上浏览代币化的房地产项目。每个项目预览都包括高级信息，如资产类型、位置和目标回报概况":
    "Once you have an account, you can browse tokenized real estate projects on the platform; each project preview includes high-level information such as asset type, location, and target return profile",
  "随着您进一步完成入职流程，详细的项目信息将变得可用":
    "Detailed project information becomes available as you proceed further through the onboarding process",
  "完整身份验证(KYC)": "Complete Identity Verification (KYC)",
  验证您的身份: "Verify your identity",
  "在投资之前，所有投资者都必须完成身份验证。此过程有助于确保法规遵从性并保护平台的完整性":
    "Before investing, all investors must complete identity verification; this process helps ensure regulatory compliance and protect the integrity of the platform",
  身份验证是受监管投资平台的标准要求:
    "Identity verification is a standard requirement for regulated investment platforms",
  "投资前需要验证，但不仅仅是创建账户":
    "Verification is required before investing, but goes beyond just creating an account",
  连接您的钱包: "Connect your wallet",
  连接数字钱包: "Connect a digital wallet",
  "要投资一个项目，您需要将数字钱包连接到您的Ternova账户。这使您能够以数字和安全的方式持有代币化的所有权权益。":
    "To invest in a project, you need to connect your digital wallet to your Ternova account; this allows you to hold tokenized ownership interests digitally and securely",
  "支持的选项包括：MetaMask（自我保管）、Ternova的平台钱包":
    "Supported options include: MetaMask (self-custody), Ternova's platform wallet",
  "未来可能会支持其他钱包选项。":
    "Other wallet options may be supported in the future",
  "只有当您准备投资时，才需要钱包连接。":
    "Wallet connection is only required when you are ready to invest",
  投资一个项目: "Invest in a project",
  投资现实世界资产: "Invest in Real World Assets",
  "当你通过Ternova投资时，你购买的是一个代表现实世界资产股权的代币。":
    "When you invest through Ternova, you are purchasing a token that represents equity in a Real World Asset",
  "这些代币的功能类似于数字股票证书，反映了特定财产或投资结构的所有权。":
    "These tokens function similarly to digital stock certificates, reflecting ownership in a specific property or investment structure.",
  "投资代币通常通过特殊目的载体（SPV）或基金进行结构化。":
    "Investment tokens are typically structured through a Special Purpose Vehicle (SPV) or fund.",
  "有关这些结构的更多信息，请参阅参考资料部分":
    "For more information on these structures, please refer to the resources section",
  退货与参与: "Returns and Participation",
  退货和参与: "Returns and Participation",
  "根据项目的不同，投资者可能会参与：持续的现金流分配长期价值增值":
    "Depending on the project, investors may participate in: ongoing cash flow distributions / long-term value appreciation",
  "分销时间和结构是特定于项目的，并在每个产品中进行了概述。":
    "Distribution timing and structure are project-specific and outlined in each offering",
  "根据项目的不同，退货可能会分配到您连接的钱包或附属银行账户。":
    "Depending on the project, returns may be distributed to your connected wallet or a linked bank account",
  "所有投资都有风险。房地产投资可能会受到市场状况、运营因素和更广泛的经济趋势的影响。":
    "All investments carry risk. Real estate investments can be affected by market conditions, operational factors, and broader economic trends.",
  "投资前请仔细审查所有项目材料和披露。每次发行都有完整的法律披露。":
    "Please carefully review all project materials and disclosures before investing. Each offering has complete legal disclosures.",
  探索项目: "Explore Projects",
  "本页面内容旨在帮助您做出更充分的信息判断，并不替代您自身的评估或专业建议":
    "The content on this page is intended to help you make a more informed judgment and does not substitute your own evaluation or professional advice",
  在Ternova上探索真实世界资产: "Explore Real World Assets on Ternova",
  "浏览下面的当前和即将到来的机会。账户创建和身份验证后，可获得完整的详细信息。":
    "Browse current and upcoming opportunities below. Complete details are available after account creation and identity verification.",
  Ternova提供能产生收入的房地产的象征性股权权益:
    "Ternova offers tokenized equity interests in income-producing real estate",
  " 每个项目都代表着对实际资产的所有权，其结构是为了透明度和长期参与。":
    "Each project represents an ownership stake in a real asset, structured for transparency and long-term engagement.",
  查看详情: "Details",
  项目名称: "Project Name",
  资产类型: "Asset Type",
  所在地: "Location",
  规模: "Scale/Size",
  资产概览: "Asset Overview",
  投资概览: "Investment Overview",
  所有权与结构: "Ownership & Structure",
  回报与参与方式: "Returns & Participation",
  文件与链接: "Documents & Links",
  立即投资: "Invest Now",
  "每个项目都代表着对实际资产的所有权，其结构是为了透明度和长期参与。":
    "Each project represents an ownership stake in a real asset, structured for transparency and long-term engagement.",
  话题: "Topics",
  首页: "Home",
  项目: "Projects",
  启动应用: "Launch App",
  "Ternova提供能产生收入的房地产的象征性股权权益。每个项目都代表着对实际资产的所有权，其结构是为了透明度和长期参与":
    "Ternova offers tokenized equity interests in income-producing real estate. Each project represents an ownership stake in a real asset, structured for transparency and long-term engagement.",
  创建您的Ternova帐户: "Create Your Ternova Account",
  "开始使用Ternova首先要创建一个帐户。创建帐户很简单，您可以探索项目、查看机会，并了解更多关于平台工作原理的信息。":
    "Getting started with Ternova begins with creating an account; account creation is simple, allowing you to explore projects, view opportunities, and learn more about how the platform works",
  "这些代币的功能类似于数字股票证书，反映了特定财产或投资结构的所有权":
    "These tokens function similarly to digital stock certificates, reflecting ownership in a specific property or investment structure",
  "投资通常通过特殊目的载体（SPV）或基金进行结构化":
    "Investment tokens are typically structured through a Special Purpose Vehicle (SPV) or fund",
  "在 Ternova 上，钱包用于在完成投资后存储代币化的资产所有权。投资者可以选择自托管钱包（如 MetaMask），或使用平台支持的钱包方式":
    "On Ternova, wallets are used to store tokenized asset ownership after completing an investment. Investors can choose a self-custody wallet (like MetaMask) or use the platform-supported wallet option",
  浏览项目是否需要连接钱包: "Is wallet connection required to browse projects?",
  这些投资是否具有流动性: "Are these investments liquid?",
  在哪里可以查看法律披露文件: "Where can I view legal disclosure documents?",
  "投资资格取决于具体项目及适用法规。有些项目仅面向合格投资者，而另一些项目可能允许更广泛的参与":
    "Investment eligibility depends on the specific project and applicable regulations. Some projects are only available to accredited investors, while others may allow broader participation",
  "身份认证在投资前必须完成。创建账户和浏览项目不需要进行身份认证":
    "Identity verification must be completed before investing. Creating an account and browsing projects does not require identity verification",
  "不需要,只有在准备投资时才需要连接钱包。":
    "No, wallet connection is only required when you are ready to invest.",
  "不需要,只有在准备投资时才需要连接钱包":
    "No, wallet connection is only required when you are ready to invest",
  "回报方式取决于具体项目，可能发放至连接的钱包或关联的银行账户":
    "Returns depend on the specific project and may be distributed to your connected wallet or a linked bank account",
  "房地产投资通常以长期持有为主。代币化旨在提供比传统结构更高的灵活性，但流动性仍可能有限，并取决于具体项目":
    "Real estate investments are typically long-term holdings. Tokenization aims to provide greater flexibility than traditional structures, but liquidity may still be limited and depends on the specific project",
  "每个项目均包含详细的披露文件和发行资料，投资前应仔细阅读":
    "Each project includes detailed disclosure documents and offering materials, which should be carefully read before investing.",
  创建账户: "Create Account",
  关注我们: "Follow Us",
};
